import React from 'react';
import ParticipantAccountSummaryCard from './components/ParticipantAccountSummaryIndex.jsx';

const ParticipantAccountSummary = () => {
  return <ParticipantAccountSummaryCard />;
}

export default ParticipantAccountSummary;
